import { inject } from "@angular/core";
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionService } from "src/app/services/session.service";

export const authTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const sessionService = inject(SessionService);

  // El token se pasa como Authorization: token (sin Bearer)
  return new Observable<HttpEvent<any>>((subscriber) => {
    sessionService.getToken().then((token) => {
      const authReq = token
        ? req.clone({
            setHeaders: { Authorization: token },
          })
        : req;
      next(authReq).subscribe({
        next: (event) => subscriber.next(event),
        error: (err) => subscriber.error(err),
        complete: () => subscriber.complete(),
      });
    });
  });
};
